var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Password_24",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.77 0 0 0.77 12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#1AAEFF",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-13, -13)",
    d: "M 13 0 C 10.320313 0 8.195313 0.832031 6.84375 2.34375 C 5.492188 3.855469 5 5.839844 5 7.90625 L 5 9 L 8 9 L 8 7.90625 C 8 6.3125 8.359375 5.128906 9.0625 4.34375 C 9.765625 3.558594 10.898438 3 13 3 C 15.105469 3 16.238281 3.535156 16.9375 4.3125 C 17.636719 5.089844 18 6.296875 18 7.90625 L 18 9 L 21 9 L 21 7.90625 C 21 5.828125 20.511719 3.820313 19.15625 2.3125 C 17.800781 0.804688 15.675781 0 13 0 Z M 5 10 C 3.34375 10 2 11.34375 2 13 L 2 23 C 2 24.65625 3.34375 26 5 26 L 21 26 C 22.65625 26 24 24.65625 24 23 L 24 13 C 24 11.34375 22.65625 10 21 10 Z M 7 16 C 8.105469 16 9 16.894531 9 18 C 9 19.105469 8.105469 20 7 20 C 5.894531 20 5 19.105469 5 18 C 5 16.894531 5.894531 16 7 16 Z M 13 16 C 14.105469 16 15 16.894531 15 18 C 15 19.105469 14.105469 20 13 20 C 11.894531 20 11 19.105469 11 18 C 11 16.894531 11.894531 16 13 16 Z M 19 16 C 20.105469 16 21 16.894531 21 18 C 21 19.105469 20.105469 20 19 20 C 17.894531 20 17 19.105469 17 18 C 17 16.894531 17.894531 16 19 16 Z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.e028893d11a853ed9c9755eef693801e.svg";
export { ForwardRef as ReactComponent };